import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbsModule } from '@fantaz/shared/layout/breadcrumbs';
import { SharedLayoutFooterModule } from '@fantaz/shared/layout/footer';
import { NavbarModule } from '@fantaz/shared/layout/navbar';
import { ColorSchemeService } from '@fantaz/shared/services/color-scheme';

@Component({
  selector: 'fz-user-game-profile-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NavbarModule,
    SharedLayoutFooterModule,
    BreadcrumbsModule,
  ],
  templateUrl: './user-game-profile-layout.component.html',
  styleUrls: ['./user-game-profile-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserGameProfileLayoutComponent {
  constructor(private readonly colorSchemeService: ColorSchemeService) {
    this.colorSchemeService.init();
  }

  get colorScheme() {
    return this.colorSchemeService.get();
  }
}
